import { request } from './client.js';
import type {
  EventFeed,
  EventRecord,
  EventSearchPage,
  EventSearchRequest,
  EventSearchStarted,
  RawEventRecord,
} from './types.js';

const tenantPath = (clientTenantId: string) => `/tenants/${encodeURIComponent(clientTenantId)}`;

/** Start a search; poll `getEventSearchPage` until it is no longer `running`. */
export function startEventSearch(
  clientTenantId: string,
  search: EventSearchRequest,
  idToken: string,
): Promise<EventSearchStarted> {
  return request<EventSearchStarted>('POST', `${tenantPath(clientTenantId)}/events/search`, idToken, {
    body: search,
  });
}

export function getEventSearchPage(
  clientTenantId: string,
  searchId: string,
  idToken: string,
  cursor?: string,
): Promise<EventSearchPage> {
  return request<EventSearchPage>(
    'GET',
    `${tenantPath(clientTenantId)}/events/search/${encodeURIComponent(searchId)}`,
    idToken,
    cursor ? { query: { cursor } } : undefined,
  );
}

const eventPath = (clientTenantId: string, feed: EventFeed, dt: string, eventUid: string) =>
  `${tenantPath(clientTenantId)}/events/${encodeURIComponent(feed)}/${encodeURIComponent(dt)}/${encodeURIComponent(eventUid)}`;

export function getEvent(
  clientTenantId: string,
  feed: EventFeed,
  dt: string,
  eventUid: string,
  idToken: string,
): Promise<EventRecord> {
  return request<EventRecord>('GET', eventPath(clientTenantId, feed, dt, eventUid), idToken);
}

export function getRawEvent(
  clientTenantId: string,
  feed: EventFeed,
  dt: string,
  eventUid: string,
  idToken: string,
): Promise<RawEventRecord> {
  return request<RawEventRecord>('GET', `${eventPath(clientTenantId, feed, dt, eventUid)}/raw`, idToken);
}
